import InventoryListingBodyV2 from './InventoryListingBodyV2';
export default InventoryListingBodyV2;